import { ContestListData } from "../../../../types/contest";
import { trackEvent } from "../../../../services/analyticsService";
import Template from "../../../../components/Template/Template";
import Carousel from "../../../../components/Carousel/Carousel";
import styles from "./index.module.scss";
import {
  formatDateToDDMM,
  formatTimeToHHMM,
} from "../../../../utils/dateFormatters";
import { PlayDataDone, PlaysListData } from "../../../../types/plays";
import { ContestListFormattedData } from "../../../../types/contest";

interface ContestCloseProps {
  contestsListJsonFormatted: ContestListFormattedData;
  playList?: PlaysListData | null;
}

export default function ContestClose({
  contestsListJsonFormatted,
  playList,
}: ContestCloseProps) {

  return (
    <>
      {/* Contest futuri */}
      {contestsListJsonFormatted.future.length > 0 ? (
        <div className={styles.contestsSection}>
            {contestsListJsonFormatted.today === true ? (
              <div className={styles.nextContestsList}>
                {/* <h2 className='f-regular'>
                  <strong>
                    Heeey, come va?
                  </strong>
                </h2> */}
                <p className='f-regular'>
                  Scopri tutte le date disponibili per partecipare al quiz
                </p>
                <div className={styles.contestsCarouselWrapper}>
                  <Carousel
                    slidesPerView={1}
                    spaceBetween={16}
                    loop={false}
                    effect='fade'
                    pagination={false}
                    navigation={true}
                    className={styles.contestsCarousel}
                  >
                    {contestsListJsonFormatted.future.map((contest: ContestListData, contestIndex: number) => (
                      <a
                        key={contestIndex}
                        className={styles.card}
                        onClick={() => trackEvent('ICS Event', 'ICS Event - Click', `ICS - ${formatDateToDDMM(contest.startDate).slice(0,2)}-${formatDateToDDMM(contest.startDate).slice(3,5)}--${formatTimeToHHMM(contest.startDate).replace(':','-')}`)}
                        href={`https://www.mcdonalds.it/friends-quiz--${formatDateToDDMM(contest.startDate).slice(0,2)}-${formatDateToDDMM(contest.startDate).slice(3,5)}--${formatTimeToHHMM(contest.startDate).replace(':','-')}?openOutsideMcd=true`}
                      >
                        {formatDateToDDMM(contest.startDate)} h {formatTimeToHHMM(contest.startDate)}
                      </a>
                    ))}
                  </Carousel>
                </div>
                <p className={styles.note}>
                  Clicca sulla data<br />
                  per aggiungerla al tuo calendario.
                </p>
              </div>
            ) : contestsListJsonFormatted.future.length > 0 ? (
              <>
                <h2 className='f-regular'>
                  <strong>
                    OH. MIO. DIO.<br />Oggi non è previsto nessun Quiz.
                  </strong>
                </h2>
                <p>
                  Oggi non è previsto nessun Quiz.
                </p>
              </>
            ) : ''}
        </div>
      ) : (
        <>
            <h2>
                NON SONO PREVISTI PROSSIMI QUIZ
            </h2>
        </>
      )}
      {/* {contestsListJsonFormatted.past.length > 0 && (
        <div className={styles.contestsSection} style={{ marginTop: '4rem', marginBottom: 'auto' }}>
          <h2>DATE PASSATE</h2>
          <ul className={styles.contestsPastList}>
            {contestsListJsonFormatted.past
              .reverse()
              .map((contest: ContestListData, contestIndex: number) => (
              <li key={contestIndex}>
                {playList &&
                  playList.plays.some(
                  (play: PlayDataDone) =>
                    play.contestId === contest.id
                ) ? (
                <>
                  <p className={styles.participationStatusDone}>
                    HAI PARTECIPATO
                    {playList.plays.find(
                      (play) => play.contestId === contest.id,
                    )?.winner && (
                      <>
                        E HAI VINTO IL
                      </>
                    )}
                  </p>
                </>
                ) : (
                <p className={styles.participationStatusNotDone}>
                  <strong>
                    NON HAI PARTECIPATO IL
                  </strong>
                </p>
                )}
                <p className={styles.card}>
                  {formatDateToDDMM(contest.startDate)} h {formatTimeToHHMM(contest.startDate)}
                </p>
              </li>
            ))}
          </ul>
        </div>
      )} */}
    </>
  );
}
